const Projects = [
    [
        {
            title: 'Konduct',
            description: 'A fullstack online course conduct platform, which allows instructors to post, modify and grade assignments and allows students to view, edit and post multiple submissions',
            cover: 'images/projects/konduct/1.png',
            tags: ['React', 'HTML', 'Tailwind', 'MUI', 'NodeJS', 'JWT Auth', 'Javascript',],
            projectLink: 'https://github.com/AtharvaUmbarkar/Konduct',
            imageLinks: ['links to project images']
        },
        {
            title: 'iNotebook',
            description: 'A CRUD operations based online platform where users can create, edit and store text notes on the go, along with appropriate tags',
            cover: 'images/projects/inotebook/1.png',
            tags: ['React', 'Mongoose', 'NodeJS', 'ExpressJS', 'REST Api', 'CRUD'],
            projectLink: 'https://github.com/AtharvaUmbarkar/iNotebook',
            imageLinks: ['links to project images']
        },
        {
            title: 'Summoner Search',
            description: 'An API based project which aims at parsing and visualizing large data, using the RIOT API. View League of Legends player profile and statistics, along with a detailed match history page.',
            cover: 'images/projects/summoner-search/1.png',
            tags: ['React', 'Tailwind', 'RIOT API', 'Data Visualization', 'CSS', 'Javascript'],
            projectLink: 'https://github.com/AtharvaUmbarkar/Summoner-Search',
            imageLinks: ['links to project images']
        },
        {
            title: 'BUCX',
            description: 'Handled UX and state management in a coupon rewards based app, for a stealth startup, using Flutter, Dart and Android Studio.',
            cover: 'images/projects/bucx/1.png',
            tags: ['Flutter', 'Dart', 'Android Studio', 'UX', 'Javascript'],
            projectLink: 'https://github.com/AtharvaUmbarkar/bucx-app',
            imageLinks: ['links to project images']
        },
    ],
    // [

    // ],
]

export default Projects;